//@ts-ignore
import React, { useState, useEffect, useContext, useRef, Component, ReactNode } from 'react';
import { Annotorious, OpenSeadragonAnnotator, OpenSeadragonViewer, OpenSeadragonAnnotationPopup, ImageAnnotation, AnnotationState, DrawingStyle, UserSelectAction, useAnnotations, useAnnotator, AnnotoriousOpenSeadragonAnnotator, Annotation, PopupProps, AnnotationBody, User, AnnotoriousContext, ShapeType} from '@annotorious/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck, faCirclePause, faEye, faMagnifyingGlass, faStopCircle, faUndo} from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { getProofFiles,getAnnotations } from '../services/apiService';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { Grid, GridCellProps, GridColumn, GridCustomCellProps, GridSelectionChangeEvent } from '@progress/kendo-react-grid';
import { getNotesList, setAnnotationStatus } from '../services/apiService';
import { ATOLAnnotation,longDateTime } from '../services/interfaces';
import '@annotorious/react/annotorious-react.css';
import { makeLongDateTime } from './DateTimeHelpers';
import { PageContext } from './PageContext';
import { CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';

interface AnnoViewerProps{
    username:string;
    userFull:string;
    element:string;
    thumbUrl:string;
}


interface LoaderProps{
    element:string;
    filter:string;
    select:string;
}
const AnnotationLoader=(loaderProps:LoaderProps)=>{
    const annotator = useAnnotator<AnnotoriousOpenSeadragonAnnotator>();
    const [annos, setAnnos] = useState<ImageAnnotation[] | "error">([]);

    useEffect(()=>{
        console.log("Filter Changed" + loaderProps.filter);
        if (annotator){
            getAnnotations(loaderProps.element,loaderProps.filter).then(anno=>{
                console.log(anno);
                setAnnos(anno);                
            });
        }
    },[annotator, loaderProps.filter])

    useEffect(()=>{
        console.log("Anno Effect");
        if (annos!="error" && annotator){
            annotator.setAnnotations(annos)
            if (loaderProps.select!=""){
                //annotator.setSelected(undefined);
                annotator.setSelected(loaderProps.select.toLowerCase());
                annotator.getSelected().forEach(anno=>{
                    console.log(anno.target);
                })
            }
        }
    },[annos])

    useEffect(()=>{
        console.log("Select effect");
        console.log(loaderProps.select);
        if (annotator){
           annotator.setSelected();
        }
    },[loaderProps.select])
    return <div></div>;
}



const ClearSelectedAnnotations=()=>{
    const annotator = useAnnotator<AnnotoriousOpenSeadragonAnnotator>();
    annotator.setSelected(undefined);
}

export const AnnotationViewer =React.forwardRef((viewerProps:AnnoViewerProps,ref)=>{
    const pageContext = useContext(PageContext);    
    const [drawingEnabled,setDrawingEnabled] = useState(true);
    const [annoColor, setAnnoColor]=useState('rgba(255, 0, 0, 1)');
    const [notesList, setNotesList] = useState<ATOLAnnotation[] | "error">([]);
    const [noteFilter, setNoteFilter] = useState({ text: "Incomplete notes", value: "0" });
    const [selNote,setSelNote]=useState("");
    const annStyle = (annotation: ImageAnnotation, state?: AnnotationState): DrawingStyle => ({
        fill: state?.selected ? ('rgba(0, 167, 84, 1)') : (annoColor as any),
        fillOpacity: 0.25,
    });
    const [proofUrl, setProofUrl]=useState("");

    interface ExtendedPopupProps extends PopupProps {
        readOnly: Boolean
    }
    const CommentPopup = (props: ExtendedPopupProps) => {
        const { annotation, onCreateBody, onUpdateBody } = props;
        const [comment, setComment] = useState('');
        const user:User = {
            name:viewerProps.userFull||'',
            id:viewerProps.username||''
        }

        const onComplete = (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            console.log(annotation.id);
            const updated:Partial<AnnotationBody> = {
            annotation: annotation.id,
            purpose: 'commenting',
            value: comment,
            creator:user
            };
        }


        useEffect(() => {
        if (annotation.bodies.length>0){
            const commentBody = annotation.bodies.find(body => body.purpose === 'commenting');
            setComment(commentBody?.value ?? '');
        }
        }, [annotation.bodies]);
            
        return (
        <>
            <div>{annotation.target.creator?.id}&nbsp;{annotation.target.created?.toDateString()}<br/>{annotation.target.created?.toTimeString()}</div>
            {!props.readOnly? 
                <textarea
                value={comment}
                onChange={e => setComment(e.target.value)} />
            : <p>{comment}</p>
            }
            <Button fillMode={"flat"} onClick={onComplete}><FontAwesomeIcon style={{color:"green"}} icon={faCheck} />&nbsp;Complete</Button>
        </>
        )
    }

    const selectNote = (event:GridSelectionChangeEvent): void => {
        //console.log(event.startDataItem);
        const tagid = event.startDataItem.tagid
        //console.log(tagid);
        setSelNote(tagid);
    }

    const getNotes=()=>{
        getNotesList(viewerProps.element).then(notes=>{
            console.log(notes);
            if (notes === "error") {
                setNotesList("error");
                return;
            }
            var filteredNotes=[];
            var filterValue = noteFilter.value;
            if (filterValue!=="3"){
                const filter: CompositeFilterDescriptor = {
                    logic: "or",
                    filters: [
                        { field: 'tag_status', operator: 'eq', value: filterValue },
                        { field: 'tagid', operator: 'eq', value: 'NEW PROOF' }
                    ]
                };
                filteredNotes = filterBy(notes, filter);
            }else{
                filteredNotes=notes;
            }
            setNotesList(filteredNotes);
        })
    }

    const getViewer=()=>{
        if (viewerProps.thumbUrl!=""){
            setProofUrl(viewerProps.thumbUrl);
        }else{
            getProofFiles(viewerProps.element).then(data => {
                setProofUrl(data.thumbURL);
            });
        }
    }

    const formatCell=(e:GridCustomCellProps)=>{
        const username=e.dataItem.user_name;
        const longDtStr = e.dataItem.time_stamp.toString();
        //var longDtStr = makeLongDateTime(dtStr);
        var locale=pageContext?.glSettings.Locale
        const longDateTime:longDateTime = {
            year:longDtStr.substring(0,4),
            month:longDtStr.substring(4,6),
            day:longDtStr.substring(6,8),
            hour:longDtStr.substring(8,10),
            minute:longDtStr.substring(10,12),
            second:longDtStr.substring(12,14),
        }
        const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
        const localDate = newDateTime.toLocaleDateString(locale,{month:"2-digit",day:"2-digit",year:"numeric", hour:"numeric", minute:"numeric"});
        const note = e.dataItem.tag_comment;
        if (e.dataItem.tagid=="NEW PROOF"){
            return (
                <td style={{backgroundColor:"green", color:"white"}}>
                    <strong>{username} - {localDate}</strong><br/>{note}
                </td>
            )
        }else{
            return(
                <td {...e.tdProps}>
                    <strong>{username} - {localDate}</strong><br/>{note}
                </td>
            )
        }
    }

    const setNotStatus=(event: React.MouseEvent<HTMLAnchorElement>,tagid:string, status:number)=>{
        event.preventDefault();
        console.log ("Update note status" + tagid + status );
        setAnnotationStatus(tagid,status).then(result=>{
            console.log("Result: " + result);

            getNotes();
        });
    }

    const notesActions=(e: GridCustomCellProps)=>{
        if (e.dataItem.tagid=="NEW PROOF"){
            return (
                <td style={{backgroundColor:"green"}}>
                </td>
            )
        }else{
            return(
                <td>
                    {e.dataItem.tag_status!==0?<a href="#" onClick={(ev) => setNotStatus(ev,e.dataItem.tagid,0)}><span style={{fontSize:"1.25em", marginRight:"5px"}}><FontAwesomeIcon icon={faUndo}></FontAwesomeIcon></span></a>:null}
                    {e.dataItem.tag_status==0?<a href="#" onClick={(ev) => setNotStatus(ev,e.dataItem.tagid,1)}><span style={{fontSize:"1.25em", color:"green", marginRight:"5px"}}><FontAwesomeIcon icon={faCheck}></FontAwesomeIcon></span></a>:null}
                    {e.dataItem.tag_status==0?<a href="#" onClick={(ev) => setNotStatus(ev,e.dataItem.tagid,2)}><span style={{fontSize:"1.25em", color:"red", marginRight:"5px"}}><FontAwesomeIcon icon={faCirclePause}></FontAwesomeIcon></span></a>:null}
                </td>
            )
        }
    }

    const filterChange=(event:DropDownListChangeEvent)=>{
        console.log(event.value);
        setNoteFilter(event.value);
    }

    useEffect(()=>{
        getNotes();
    },[noteFilter])

    useEffect(()=>{
        getViewer();
        getNotes();
        return ()=>{
            console.log("Annotator unloaded");
        };
    },[])
    return(
            <div className='row'>
            <div className='col-7'>
            {proofUrl!=""?
            <div>
               <OpenSeadragonAnnotator
                    //ref={myanno}
                    style={annStyle} 
                    tool={"rectangle"} 
                    drawingEnabled={false}
                    drawingMode='click'
                    userSelectAction={UserSelectAction.SELECT}
                    user={{name:viewerProps.userFull||"",id:viewerProps.username||""}}
                >
                    <OpenSeadragonViewer
                        //ref={myviewer}
                        className='noteImage'
                        options={{
                            tileSources:{
                                type:"image",
                                url: proofUrl,
                                ajaxWithCredentials:false,
                            },
                            crossOriginPolicy:"Anonymous",
                            defaultZoomLevel:.5,
                            minZoomLevel:.25,
                            maxZoomLevel:2,
                            gestureSettingsMouse:{clickToZoom:false},
                            prefixUrl:"https://cdn.jsdelivr.net/npm/openseadragon@latest/build/openseadragon/images/"
                        }}
                    />
                    <OpenSeadragonAnnotationPopup
                        popup={props => (    
                            <CommentPopup {...props} readOnly={true} />
                    )} />      
                </OpenSeadragonAnnotator>
                <AnnotationLoader element={viewerProps.element} filter={noteFilter.value} select={selNote}></AnnotationLoader>
                </div>
            :<></>}
            </div>
            <div className='col-5 noteList'>
                <p>ANNOTATIONS FOR THIS AD</p>
                <DropDownList
                    dataItemKey='value'
                    textField='text'
                    data={[
                        { text: "Incomplete notes", value: "0" },                    
                        { text: "Complete notes", value: "1" },
                        { text: "Hold notes", value: "2" },
                        { text: "All notes", value: "3" },
                    ]}
                    onChange={filterChange}
                    value={noteFilter}
                />
                <Grid
                    className='mt-3 notesList'
                    scrollable='scrollable'
                    dataItemKey='tagid'
                    data={notesList !== "error" ? notesList : []} 
                    selectable={{
                        enabled: true,
                        mode: 'single'
                    }}
                    onSelectionChange={selectNote}           
                >
                    <GridColumn
                        field='tagid'
                        title='&nbsp;'
                        width={"120px"}
                        cells={{data:notesActions}}
                    />
                    <GridColumn title='Notation' field='tag_comment' cells={{data:formatCell}}/>
                    <GridColumn title='Pg' field='page' width={"75px"}/>
                    
                </Grid>
            </div>
        </div>
    )
})